import React, { Fragment } from 'react';
import NavbarS4 from '../../components/NavbarS4/NavbarS4';
import PageTitle from '../../components/pagetitle/PageTitle'
import ScrollTextAnimation from '../../components/ScrollTextAnimation/ScrollTextAnimation';
import Footer from '../../components/footer/Footer';
import Scrollbar from '../../components/scrollbar/scrollbar';
import Logo from '../../images/logo2.png'
import Contactpage from '../../components/Contactpage/Contactpage'
import SEO from '../../components/Seo';

const ContactPage = () => {
    return (
        <Fragment>
            <SEO
                title="Contact LuxRock Realty | Real Estate Property Consultant"
                description="Contact LuxRock Realty for buying, selling or investing in residential and commercial properties. Call or visit us for trusted property guidance."
                keywords="contact LuxRock Realty, real estate contact, property dealer contact, real estate consultant surat"
            />

            <NavbarS4 hclass={'wpo-site-header wpo-header-style-s11'} Logo={Logo} col1={'col-lg-3 col-md-3 col-3 d-lg-none dl-block'}
                col2={'col-lg-2 col-md-4 col-6'}
                col3={'col-lg-7 col-md-1 col-1'}
                col4={'col-lg-3 col-md-4 col-2'} />
            <PageTitle pageTitle={''} pagesub={'Contact Us'} />
            <ScrollTextAnimation />
            <Contactpage />
            <section className="wpo-contact-map-section">
                <h2 className="hidden">Contact map</h2>
                <div className="wpo-contact-map">
                    <iframe title='map'
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d14685.202374175251!2d72.50690655541986!3d23.0494388!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x395e85863ca8a7f3%3A0x517947b5a18a5b6b!2sLuxrock%20Realty%20Private%20Limited!5e0!3m2!1sen!2sin!4v1770617125786!5m2!1sen!2sin"
                        allowFullScreen></iframe>
                </div>
            </section>
            <Footer />
            <Scrollbar />
        </Fragment>
    )
};
export default ContactPage;





